import React, { useEffect, useState } from "react";
import "./buttomG.css";
import { useTranslation } from "react-i18next";
import GalleryGrid from "./GalleryGrid";
import ScrollReveal from "../common/Reveal";
import SectionLoader from "../common/SectionLoader";
import { DEFAULT_PROJECT_CATEGORY_ID, PROJECT_CATEGORY_ORDER } from "../../constants/projectCategories";
import { useProjects } from "../../hooks/useProjects";
import { isRtlLanguage } from "../../utils/i18n";

function ButtonGroup() {
  const [activeElement, setActiveElement] = useState(DEFAULT_PROJECT_CATEGORY_ID);
  const { t, i18n } = useTranslation();
  const { galleries, loading, error } = useProjects();
  const isRtl = isRtlLanguage(i18n.language);

  useEffect(() => {
    if (loading || galleries.length === 0) return;

    setActiveElement((current) => {
      const currentGallery = galleries.find((gallery) => gallery.id === current);
      if (currentGallery) return current;

      const firstWithImages = galleries.find((gallery) => gallery.images.length > 0);
      return firstWithImages?.id || DEFAULT_PROJECT_CATEGORY_ID;
    });
  }, [galleries, loading]);

  const activeGallery =
    galleries.find((gallery) => gallery.id === activeElement) ||
    galleries.find((gallery) => gallery.id === DEFAULT_PROJECT_CATEGORY_ID) ||
    galleries[0];

  if (loading) {
    return <SectionLoader size="lg" label={t("Loading section")} />;
  }

  if (error) {
    return (
      <p className="gallery-grid__empty" role="status">
        {t("projects.loadError")}
      </p>
    );
  }

  return (
    <div data-reveal-managed="">
      <ScrollReveal>
        <div
          className="gallery-tabs mb-6 flex gap-2 overflow-x-auto pb-2 sm:mb-8 sm:flex-wrap sm:justify-center sm:gap-3 sm:overflow-visible lg:flex-nowrap"
          role="tablist"
          aria-label={t("Our Projects")}
          dir={isRtl ? "rtl" : "ltr"}
        >
          {PROJECT_CATEGORY_ORDER.map((id) => {
            const gallery = galleries.find((entry) => entry.id === id);
            if (!gallery) return null;

            const isActive = activeElement === id;
            return (
              <button
                key={id}
                type="button"
                role="tab"
                aria-selected={isActive}
                className={`gallery-tab b shrink-0 rounded-border px-3 py-2 text-xs font-normal transition-colors sm:px-4 sm:py-3 sm:text-sm md:text-base ${
                  isActive ? "is-active" : ""
                }`}
                onClick={() => setActiveElement(id)}
              >
                {t(gallery.labelKey)}
              </button>
            );
          })}
        </div>
      </ScrollReveal>

      <ScrollReveal>
        <div role="tabpanel">
          {activeGallery ? (
            <GalleryGrid
              key={activeGallery.id}
              images={activeGallery.images}
              descriptionKey={activeGallery.labelKey}
            />
          ) : null}
        </div>
      </ScrollReveal>
    </div>
  );
}

ButtonGroup.revealManaged = true;

export default ButtonGroup;
